export const radius = {
    none: '0px',
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '16px',
    full: '9999px',
};
//# sourceMappingURL=radius.js.map